import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { useLayout } from '../../core'
import { MutableRefObject, useEffect, useRef } from 'react'
import { ToggleComponent } from '../../../assets/ts/components'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../app/redux/store'
import { GetOrganizationSettingByIdApi } from '../../../../app/redux/slices/OrganizationSlices'
// import { GetOrganizationSettingByIdApi } from '../../../../app/redux/slices/OrganizationSlices'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarLogo = (props: PropsType) => {
  const { config } = useLayout()
  const dispatch = useDispatch<any>()
  const toggleRef = useRef<HTMLDivElement>(null)
  const user = useSelector((state:RootState)=>state.auth.user)
  const organizationSettingData = useSelector(
    (state: any) => state?.organization?.organizationSettingData?.data?.data?.data?.setting_json
  );

  const getOrganizationById = async () => {
    await dispatch(GetOrganizationSettingByIdApi(user?.organization_id))
  }

  useEffect(() => {
    if(user?.organization_id!=null)
    getOrganizationById()
  }, [user])


  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
      ? 'minimize'
      : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

      if (toggleObj === null) {
        return
      }

      // Add a class to prevent sidebar hover effect after toggle click
      toggleObj.on('kt.toggle.change', function () {
        // Set animation state
        props.sidebarRef.current!.classList.add('animating')
        // Wait till animation finishes
        setTimeout(function () {
          // Remove animation state
          props.sidebarRef.current!.classList.remove('animating')
        }, 300)
      })
    }, 600)
  }, [toggleRef, props.sidebarRef])
console.log(organizationSettingData)
  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}
    >
      <Link to='/dashboard'>
        {config.layoutType === 'dark-sidebar' ? (
          // <img
          //   alt='Logo'
          // src={organizationSettingData?.settings_json?.logo}
          //   src={toAbsoluteUrl('/media/logos/default-dark.svg')}
          //   className='h-25px app-sidebar-logo-default'
          // />hrm-logo.svg
          <img
            // alt='Logo'
            src={ organizationSettingData?.org_logo_url }
            // src={toAbsoluteUrl('/media/logos/cute_decor.png')}
            className='h-25px app-sidebar-logo-default'
          />
        ) : (
          <>
            {/* <img
              alt='Logo'
              src={organizationSettingData?.settings_json?.logo}
              src={toAbsoluteUrl('/media/logos/default.svg')}
              className='h-25px app-sidebar-logo-default theme-light-show'
            /> */}
            <img
              // alt='Logo'
              src={ organizationSettingData?.org_logo_url}
              className='h-25px app-sidebar-logo-default theme-light-show'
            />
            {/* <img
              alt='Logo'
              src={organizationSettingData?.settings_json?.logo}
              src={toAbsoluteUrl('/media/logos/hrm-logo.png')}
              className='h-25px app-sidebar-logo-default theme-light-show'
            />  */}

            <img
              // alt='Logo'
              src={ organizationSettingData?.org_logo_url }
              className='h-25px app-sidebar-logo-default theme-dark-show'
              style={{ marginLeft: '6px' }}
            />
          </>
        )}

        {/* <img
          alt='Logo'
          src={organizationSettingData?.settings_json?.logo}
          src={toAbsoluteUrl('/media/logos/favicon.png')}
          className='h-25px app-sidebar-logo-minimize'
          style={{marginLeft: '6px'}}
        /> */}

        <img
          // alt='Logo'
          src={organizationSettingData?.org_favicon_url}
          // src={toAbsoluteUrl('/media/logos/cute_decor_favicon.png')}
          className='h-25px app-sidebar-logo-minimize'
          style={{ marginLeft: '6px' }}
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            { active: appSidebarDefaultMinimizeDefault }
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTIcon iconName='double-left' className='fs-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export { SidebarLogo }
